const palette = {
  text: {
    primary: '#171717',
    neutralDark: '#393939',
    neutralLight: '#6F787F',
    inverse: '#FFFFFF',
    primaryHue: '#F2B943',
    secondaryHue: '#2B82DB',
  },
  neutral: {
    lightest: '#FFFFFF',
    lighter: '#ECEDED',
    light: '#6F787F',
    main: '#393939',
    dark: '#171717',
    input: '#B0B5B5',
  },
  primary: {
    lightest: '#FBF5E9',
    lighter: '#FAE4B7',
    light: '#F5CA70',
    main: '#F2B943',
    dark: '#C4870E',
  },
  secondary: {
    lightest: '#E9F2FB',
    lighter: '#A8CCF0',
    light: '#66A5E5',
    main: '#2B82DB',
    dark: '#0D58A5',
  },
  hitBlue: {
    main: '#0098D3',
  },
  hitYellow: {
    main: '#C4870E',
  },
  hitGreen: {
    main: '#2D6000',
  },
  hitPurple: {
    main: '#7337AB',
  },
  status: {
    success: {
      lightest: '#EEFFF3',
      main: '#2D6000',
    },
    error: {
      lightest: '#FBE9EA',
      main: '#B12C32',
    },
    warning: {
      lightest: '#FFFBED',
      main: '#C4870E',
    },
  },
}

export default palette